import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import classes from "./DietitianLayout.module.scss";
import trophia_logo from "../../assets/trophiaLogo.png";

// ── Icons ─────────────────────────────────────────────────
const IcoDash     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcoClients  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoSchedule = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcoFoods    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a10 10 0 1 0 10 10"/><path d="M12 2v10l4.5 4.5"/><path d="M18 2v6h6"/></svg>;
const IcoLogout   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;

const DietitianLayout = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const close = () => setOpen(false);

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const initials = (name: string) =>
    name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `${classes.nav_item} ${isActive ? classes.nav_item_active : ""}`;

  const inner = (
    <>
      <div className={classes.logo}>
         <img src={trophia_logo} alt="Trophia logo" className={classes.logo_logo}/> 
        </div>

      <nav className={classes.nav}>
        <div className={classes.nav_section}>Main</div>
        <NavLink to="/dietitian" end className={linkClass} onClick={close}>
          <IcoDash /><span>Dashboard</span>
        </NavLink>
        <NavLink to="/dietitian/clients" className={linkClass} onClick={close}>
          <IcoClients /><span>Clients</span>
        </NavLink>
        <NavLink to="/dietitian/schedule" className={linkClass} onClick={close}>
          <IcoSchedule /><span>Schedule</span>
        </NavLink>
        <NavLink to="/dietitian/foods" className={linkClass} onClick={close}>
          <IcoFoods /><span>Food &amp; Supplements</span>
        </NavLink>
      </nav>

      <div className={classes.sidebar_footer}>
        <div className={classes.footer_avatar}>
          {user?.name ? initials(user.name) : "TK"}
        </div>
        <div className={classes.footer_info}>
          <div className={classes.footer_name}>{user?.name ?? "Dietitian"}</div>
          <div className={classes.footer_role}>Clinical Dietitian</div>
        </div>
        <div className={classes.logout_wrap}>
          <button className={classes.logout_btn} onClick={handleLogout}>
            <IcoLogout />
          </button>
          <span className={classes.logout_label}>Log out</span>
        </div>
      </div>
    </>
  );

  return (
    <div className={classes.layout}>
      <aside className={classes.sidebar}>{inner}</aside>

      <button className={classes.burger} onClick={() => setOpen(true)} aria-label="Open menu">
        <span /><span /><span />
      </button>

      {open && <div className={classes.backdrop} onClick={close} />}

      <aside className={`${classes.drawer} ${open ? classes.drawer_open : ""}`}>
        <button className={classes.close_btn} onClick={close} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
        {inner}
      </aside>

      <main className={classes.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default DietitianLayout;
